import '../../assets/stylesheets/application.scss'
import '../components'

require('@rails/ujs').start()
require('turbolinks').start()
require('@rails/activestorage').start()
require.context('../../assets/images', true)

require('trix')
require('@rails/actiontext')
